import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import App2 from "./app2.js/App2";
import "./app/App.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "remixicon/fonts/remixicon.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-image-crop/src/ReactCrop.scss";
import { LanguageProvider } from "./app2.js/Components/LanguageContext";
import { ThemeProvider } from "./ThemeContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import { attachRequestHmac } from "./app2.js/store/hmacUtils";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

axios.interceptors.request.use((config) => {
  const url = config.url || "";
  if (!API_BASE_URL || !url.startsWith(API_BASE_URL)) {
    return config;
  }
  return attachRequestHmac(config);
});


ReactDOM.render(
  <BrowserRouter>
  <ThemeProvider>
    <LanguageProvider>
    <App2 />
    </LanguageProvider>
  </ThemeProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
